import React from 'react';
import { useSelector } from 'react-redux';
import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import useMatchingDossierContentParagraph from '../../../../hooks/useMatchingDossierContentParagraph';
import type { TaxonomyDossier as Type } from '../../../../types/taxonomy';

interface DossierMenuProps {
  entity: ImmutableEntity<Type>;
  onClick?: () => void;
}

/**
 * Renders menu items for the dossier content group that contains the current article.
 * Only shows items from the specific dossier_content paragraph matching the current page.
 */
const DossierMenu: React.FC<DossierMenuProps> = ({ entity, onClick }) => {
  const dossier = entity.toJS();
  const dossierId = dossier.tid[0].value;

  const currentEntityId = useSelector(
    (state: any) => state.getIn(['entity', 'entityId'], null),
  );

  const matchingParagraph = useMatchingDossierContentParagraph(dossier.field_paragraphs);

  if (!matchingParagraph) {
    return null;
  }

  const menuItems: any[] = matchingParagraph.entity.field_dossier_content_item;

  return menuItems?.map((item: any) => {
    const itemEntity = item.entity;
    const title = itemEntity.field_title[0].value;
    const articleId = itemEntity.field_content_dossier[0]?.target_id;
    const url = itemEntity.field_link[0]?.uri
      ?? itemEntity.field_content_dossier[0]?.url;
    const isActive = Number(currentEntityId) === articleId;
    const isExternal = url?.startsWith('http');

    const className = [
      isActive && 'MenuItem--active',
      isExternal && 'MenuItem--external',
    ].filter(Boolean).join(' ') || undefined;

    return (
      <li key={articleId} className={className}>
        <CoreLink href={`${url}?dossier_id=${dossierId}`} onClick={onClick}>
          <i className="icon icon-arrow-right icon-variant-0" />
          {title}
        </CoreLink>
      </li>
    );
  });
};

export default DossierMenu;
